import { useSelector } from 'react-redux';
import { WindxSimulacaoAntiga } from 'helper/windx';
import { selectWindxIdsSimulacoesAntigasAtivas } from 'redux/reducers/windxControlPanelReducer';
import { useGetSimulacoesAntigasQuery } from 'services/api/windx';

/**
 * Hook que deriva as simulacoes antigas ATIVAS (objetos completos) a partir
 * dos ids armazenados no Redux + cache do RTK Query.
 *
 * FE-WINDX-043 v7: retorna array (1..3 sims ativas via checkbox multi).
 * Sims cujo id desapareceu do cache (foram deletadas em outra sessao) sao
 * filtradas — UI mostra apenas as que existem.
 *
 * Uso primario: <SimulacoesAntigasSalvas> (UI checkbox) e
 * useChartDataMergedSH (orquestra 1+N chamadas paralelas ao /chart/data/).
 */
export default function useSimulacoesAntigasAtivas(): WindxSimulacaoAntiga[] {
  const ids = useSelector(selectWindxIdsSimulacoesAntigasAtivas);
  const { data: lista } = useGetSimulacoesAntigasQuery();
  if (ids.length === 0 || !lista) return [];
  // Preserva a ordem do array de ids (ordem de selecao do usuario).
  return ids
    .map((id) => lista.find((s) => s.id === id))
    .filter((s): s is WindxSimulacaoAntiga => s !== undefined);
}
